export default __webpack_public_path__ + "static/media/224.882df1d3.png";